import { observer } from 'mobx-react-lite';
import Button from '@components/core/button/button.tsx';
import { DataGranularity } from '@/enums/data-granularity.ts';

interface GranularitySelectorPros {
	updateGranularity: (granularity: DataGranularity) => unknown;
	selectedGranularity: DataGranularity;
	availableGranularities?: DataGranularity[];
}

const GranularitySelector = observer(function GranularitySelector(
	props: GranularitySelectorPros
) {
	const availableGranularities = props.availableGranularities?.length
		? props.availableGranularities
		: Object.values(DataGranularity);

	return (
		<div className={'flex items-center gap-4'}>
			{availableGranularities.includes(DataGranularity.HOUR) && (
				<Button
					title={'Hourly'}
					onClick={() => {
						props.updateGranularity(DataGranularity.HOUR);
					}}
					selected={
						props.selectedGranularity === DataGranularity.HOUR
					}
					className={
						'text-xs sm:text-sm px-2 sm:px-3 py-0 sm:py-1 h-7 sm:h-8'
					}
					small
				/>
			)}

			{availableGranularities.includes(DataGranularity.DAY) && (
				<Button
					title={'Daily'}
					onClick={() => {
						props.updateGranularity(DataGranularity.DAY);
					}}
					selected={props.selectedGranularity === DataGranularity.DAY}
					className={
						'text-xs sm:text-sm px-2 sm:px-3 py-0 sm:py-1 h-7 sm:h-8'
					}
					small
				/>
			)}

			{availableGranularities.includes(DataGranularity.WEEK) && (
				<Button
					title={'Weekly'}
					onClick={() => {
						props.updateGranularity(DataGranularity.WEEK);
					}}
					selected={
						props.selectedGranularity === DataGranularity.WEEK
					}
					className={
						'text-xs sm:text-sm px-2 sm:px-3 py-0 sm:py-1 h-7 sm:h-8'
					}
					small
				/>
			)}

			{availableGranularities.includes(DataGranularity.MONTH) && (
				<Button
					title={'Monthly'}
					onClick={() => {
						props.updateGranularity(DataGranularity.MONTH);
					}}
					selected={
						props.selectedGranularity === DataGranularity.MONTH
					}
					className={
						'text-xs sm:text-sm px-2 sm:px-3 py-0 sm:py-1 h-7 sm:h-8'
					}
					small
				/>
			)}
		</div>
	);
});

export default GranularitySelector;
